<template>
  <b-skeleton-wrapper :loading="loading">
    <template #loading>
      <b-card :class="'text-center p-3 big-number p-0 ' + colorClass">
        <div class="d-flex flex-row align-items-start justify-content-between w-100">
          <b-skeleton width="80%" height="18px" class="mb-0" />
        </div>
        <div class="d-flex flex-column align-items-start justify-content-start w-100">
          <b-skeleton width="60%" height="32px" class="mt-2" />
          <b-skeleton width="40%" height="12px" class="mt-2" />
        </div>
      </b-card>
    </template>
    <b-card :class="'text-center p-3 big-number p-0 ' + colorClass">
      <div class="d-flex flex-row align-items-start justify-content-between w-100">
        <h6 class="title text-left m-0 font-weight-normal text-muted">
          {{ title }}
        </h6>
        <span v-if="tooltip" class="d-inline-block" style="position: relative;">
          <img
            :src="require('@/assets/img/icons/info.svg')"
            alt="icone de informação"
            ref="infoIcon"
            style="cursor: pointer;"
          />
          <b-tooltip
            :target="() => $refs.infoIcon"
            :title="tooltip"
            placement="top"
          />
        </span>
        <img v-else :src="require('@/assets/img/icons/info.svg')" alt="icone de informação" />
      </div>
      <div class="d-flex flex-column align-items-start justify-content-start w-100">
        <h3 :class="'number text-left font-weight-bold m-0 ' + colorClass">
          {{ number }}
        </h3>
        <small :class="'subtitle text-left ' + colorClass">
          {{ formattedSubnumber }}
        </small>
      </div>
    </b-card>
  </b-skeleton-wrapper>
</template>

<script>
export default {
  name: "BigNumber",
  props: {
    number: {
      type: String,
      required: true
    },
    title: {
      type: String,
      required: true
    },
    subnumber: {
      type: String,
      required: false,
      default: ""
    },
    subnumberDescription: {
      type: String,
      required: false
    },
    tooltip: {
      type: String,
      required: false
    },
    type: {
      type: String,
      required: false,
      default: "info",
      validator: function (value) {
        return ["info", "warning", "danger"].includes(value);
      }
    },
    loading: {
      type: Boolean,
      required: false,
      default: true
    }
  },
  computed: {
    colorClass() {
      return `highlight-${this.type}`;
    },
    formattedSubnumber() {
      if (!this.subnumber) {
        return ' ';
      }
      return this.subnumber + ' ' + this.subnumberDescription;
    }
  }
};
</script>

<style scoped>
::v-deep(.card-body) {
  padding: 0 !important;
  display: flex;
  flex-direction: column;
  align-items: start;
  justify-content: space-between;
  height: 100%;
}

.big-number {
  font-size: 48px;
  font-weight: bold;
  color: #333;
  border: 1px solid #ccc;
  border-radius: 8px;
  padding: 24px;
  min-width: 200px;
  max-width: 200px;
  min-height: 136px;
}

.highlight-info {
  border-color: #0E499A;
  color: #0E499A;
}

.highlight-warning {
  border-color: #D97706;
  color: #D97706;
}

.highlight-danger {
  border-color: #DC2626;
  color: #DC2626;
}

.subtitle {
  font-size: 0.25em;
  min-height: 1.8em;
}

.number {
  font-size: 1.5rem;
}

.title {
  font-size: 14px;
}


</style>